
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanSouth as ObiBuoyCanSouthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-south.js';
 
 
 

 
 export const ObiBuoyCanSouth = createComponent({
   react: React,
   tagName: 'obi-buoy-can-south',
   elementClass: ObiBuoyCanSouthElement,
   events: {
     
   }
  });
 
 